export default __webpack_public_path__ + "static/media/hinge6.ec042803.jpg";